import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'sal_center': {
    title: '公司/营销单元',
    type: 'select',
    equation: all,
    dictionary: 'saleCompnay'
  },
  'sal_center_name': {
    title: '公司/营销单元描述',
    type: 'input'
  }
}

export default {
  'plan_order': {
    title: '单据编号',
    type: 'input',
    equation: all,
    slot: true
  },
  'order_type': {
    describe: true,
    title: '单据类型',
    type: 'select',
    equation: city,
    dictionary: 'A0021',
    width: 200
  },
  'sal_center_name': {
    // describe: true,
    title: '公司/营销单元'
    // // type: 'select',
    // equation: all,
    // dictionary: 'sale'
  },
  'porder_status': {
    describe: true,
    title: '状态',
    type: 'select',
    equation: city,
    dictionary: 'A0023'
  },
  'create_name': {
    title: '创建人',
    type: 'input',
    equation: cusname
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue),
    defaultVal: new Date()
  },
  'plan_number': {
    title: '销售计划编号',
    type: 'input',
    equation: all
  },
  'remark': {
    title: '备注',
    type: 'input',
    equation: cusname
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    showDescribeInput: true,
    describeTitle: '存货分类描述',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'plan_qty': {
    title: '计划量(吨)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'plan_amt': {
    title: '计划额(万元)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanOrderQueryCompany.js